import { BuiltCampaignControllerTrigger } from "src/shared/store/campaign-built/model/BuiltCampaignControllerTrigger";
export class BuiltCampaignControllerTriggerMaxMind extends BuiltCampaignControllerTrigger {
    constructor(response, context) {
        super(response, context);
        this.defaultQualityScore = response.default_quality_score;
        this.riskThreshold = response.risk_threshold;
        this.ipThreshold = response.ip_threshold;
        this.allowHighRiskEmail = response.allow_high_risk_email;
    }
    static isBuiltCampaignControllerTriggerMaxMind(trigger) {
        return trigger instanceof BuiltCampaignControllerTriggerMaxMind;
    }
}
export const isBuiltCampaignControllerTriggerMaxMind = (trigger) => {
    return trigger instanceof BuiltCampaignControllerTriggerMaxMind;
};
